<template>
  <div class="col-xs-12" v-show="!isEmpty">
      <div class="form-group">
          <a href="#show-errors" v-on:click="showMessages($event)">
              <span class="glyphicon glyphicon-exclamation-sign"></span>
              {{ this.getLabel('_cartItemsErrorMessage') }}
          </a>
      </div>        

      <div class="alert alert-warning" 
        v-for="status in state.cartsStatus" 
        v-show="state.status.showAdjustments">
          {{ status.Message }}
      </div>
  </div>
</template>
<script>
  import { store } from './../store.js';
  import { shared } from './../shared.js';

  export default {
      mixins: [shared],
      data: function () {
          return {
              state: store.state
          }
      },
      computed: {
          isEmpty: function () {
              return store.state.cartsStatus.length == 0 || store.state.carts.length == 0;
          }
      },
      methods: {
          showMessages: function (event) {
              event.preventDefault();
              store.toggleMessages();
          }
      }
  }
</script>